// frontend/src/pages/SettingsNotifications.jsx
import PageContainer from '../components/common/PageContainer'
import ViewHeader from '../components/ViewHeader'
import UserPreferencesPanel from '../components/notifications/UserPreferencesPanel'

export default function SettingsNotifications() {
  return (
    <PageContainer>
      <ViewHeader title="Notification preferences" breadcrumbs={[{ label: 'Settings' }, { label: 'Notifications' }]} />
      <UserPreferencesPanel />
    </PageContainer>
  )
}
